import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { FileText, Users } from 'lucide-react'
import {
  APPLY_NOW_SHELL_LABELS,
  AUTH_CONTENT,
} from '../constants/authContent'
import { ApplyNowShell } from '../components/ApplyNowShell'
import { ApplyChoiceOption } from '../components/ApplyChoiceOption'
import { ApplyStepHeader } from '../components/ApplyStepHeader'
import type { ApplyNowProps, Step1Choice } from '../types'

const copy = AUTH_CONTENT.applyNow.step1

/**
 * Mirrors Angular register `haveappliedinfo` tab.
 * Content from AUTH_CONTENT; UI via presentational components.
 */
export function ApplyNow({ onContinue }: ApplyNowProps = {}) {
  const navigate = useNavigate()
  const [choice, setChoice] = useState<Step1Choice>('yes')

  const handleContinue = () => {
    // Parent-driven (in-place wizard at `/apply/:inviteId`) takes precedence.
    if (onContinue) {
      onContinue(choice)
      return
    }
    if (choice === 'no') {
      navigate('/apply-now/need-to-apply-first')
      return
    }
    navigate('/apply-now/invite-code-question')
  }

  return (
    <ApplyNowShell
      labels={APPLY_NOW_SHELL_LABELS}
      onContinue={handleContinue}
    >
      <ApplyStepHeader
        title={copy.title}
        description={copy.subtitle || undefined}
      />

      <div
        role="radiogroup"
        aria-label={copy.title}
        className="grid grid-cols-1 gap-2.5 sm:grid-cols-2 sm:items-stretch sm:gap-3"
      >
        <ApplyChoiceOption
          name="applied-at-property"
          value="no"
          layout="grid"
          selected={choice === 'no'}
          onSelect={() => setChoice('no')}
          title={copy.noOption}
          description={copy.noDescription}
          icon={<FileText className="h-4 w-4" aria-hidden="true" />}
        />
        <ApplyChoiceOption
          name="applied-at-property"
          value="yes"
          layout="grid"
          selected={choice === 'yes'}
          onSelect={() => setChoice('yes')}
          title={copy.yesOption}
          description={copy.yesDescription}
          icon={<Users className="h-4 w-4" aria-hidden="true" />}
        />
      </div>
    </ApplyNowShell>
  )
}
